import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import { REPORT_CARD_OPTIONS, REPORT_CARD_STATUS } from '../../../../utilities/constants';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { showAlert } from '../../../../utilities/notifications';
import { cardProviders, CardState } from '../../constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import RadioButton from '../../../../components/RadioButtonGroup';
import { cardSettingsScreens } from '../constants';

const ReportCardIssue = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const { state, openScreen } = useContext(CardSettingsContext);

  const cardProvider = state?.user?.cardProvider;
  const cardStatus = state?.cardStatus;

  const [isDisable, setIsDisable] = useState(true);
  const [securityOptions, setSecurityOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [ledgerSupportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  useEffect(() => setSecurityOptions(REPORT_CARD_OPTIONS[cardProvider]), [cardProvider]);

  const handleOnChange = (item) => {
    const _securityOptions = securityOptions.map((option) => {
      if (option.state === item.state) {
        const _selectedOption = {
          ...option,
          selected: true,
        };
        setSelectedOption(_selectedOption);
        return _selectedOption;
      }
      return {
        ...option,
        selected: false,
      };
    });
    setIsDisable(false);
    setSecurityOptions(_securityOptions);
  };

  const handleReportCard = () => {
    if (cardStatus?.hasPendingBufferAuthorizations) {
      showAlert({
        message: translate('monavate_report_card_issue_pending_transactions_error_note').replace(
          '__SUPPORT_EMAIL__',
          ledgerSupportEmailAddress
        ),
        type: 'danger',
        showIcon: true,
        blockAutoDismiss: true,
      });
      setIsDisable(true);
      return;
    }

    if (cardProvider === cardProviders.GALILEO) {
      openScreen(cardSettingsScreens.REPORT_CARD_CONFIRM, selectedOption);
    } else if (selectedOption.state === REPORT_CARD_STATUS.DAMAGED) {
      openScreen(cardSettingsScreens.ORDER_REPLACEMENT_CARD, {
        withBack: true,
      });
    } else if ([CardState.STOLEN, CardState.LOST].includes(cardStatus?.cardState)) {
      openScreen(cardSettingsScreens.ORDER_REPLACEMENT_CARD, selectedOption);
    } else {
      openScreen(cardSettingsScreens.REPORT_CARD_CONFIRM, selectedOption);
    }
  };

  const handlePrevClick = () => {
    history.push('/dashboard/card/details');
  };

  return (
    <MainBodyLayout
      withBack
      onPrevClick={handlePrevClick}
      title={translate('manage_card_report_card_issue')}>
      <div style={{ letterSpacing: 0.3 }} className="text-f5 mt-4 mb-4 lh-base">
        {cardProvider === cardProviders.MONAVATE
          ? translate('monavate_lost_stolen_label')
          : translate('security_settings_alert')}
      </div>
      <div className="mb-4">
        <RadioButton data={securityOptions} onChange={handleOnChange} className="bg-lighter" />
        {cardProvider === cardProviders.MONAVATE && (
          <div className="alert alert-info d-flex mt-4" role="presentation">
            <i className="icon icon-info-icon position-relative start-0" />
            <div className="content">
              {translate('monavate_report_card_issue_ensure_no_pending_transactions_note')}
            </div>
          </div>
        )}
        {cardProvider !== cardProviders.MONAVATE && selectedOption?.label && (
          <div className="mt-4 mb-4">
            {translate(selectedOption?.label, { state: selectedOption.state })}
          </div>
        )}
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0', left: '0', zIndex: 100 }}>
        <button
          disabled={isDisable}
          type="button"
          className="btn py-3 btn-primary w-100"
          onClick={handleReportCard}>
          {cardProvider === cardProviders.GALILEO
            ? translate('continue_btn_title')
            : translate('confirm_btn_title')}
        </button>
      </div>
    </MainBodyLayout>
  );
};

export default ReportCardIssue;
